export { default as DataTable } from './DataTableReact';
export type { Column, DataTableProps, TableAction } from './types';
